import React from 'react'
import { string } from 'prop-types'

import ContentWrapper from 'components/atoms/ContentWrapper'
import SectionContainer from 'components/atoms/SectionContainer'
import Container from 'components/atoms/Container'
import SectionTitle from 'components/atoms/SectionTitle'
import AdmissionRegistrationButton from 'components/molecules/AdmissionRegistrationButton'

const SchoolRegistration = ({ registrationInfo, registrationUrl }) => (
  <div className="school-registration" id="registration">
    <SectionContainer paddingTop={80}>
      <Container>
        <SectionTitle title="Pendaftaran" />
        <ContentWrapper content={registrationInfo} />
        {
          registrationUrl &&
          <div className="school-registration__button-wrapper">
            <AdmissionRegistrationButton type="campus" />
          </div>
        }
      </Container>
    </SectionContainer>
    <style jsx>
      {`
        .school-registration {
          &__button-wrapper {
            text-align: center;
            margin: 16px 0;
          }
          :global(&__button) {
            font-size: 14px;
            font-weight: bold;
            box-shadow: 0 2px 4px 0 rgba(107, 143, 188, 0.85);
            padding: 14px 28px;
            border: none;
            margin: 8px;
          }
          :global(h3, h4) {
            color: #0c2846;
            font-size: 16px;
            @media screen and (min-width: 768px) {
              font-size: 20px;
            }
          }
          :global(h3) {
            font-weight: bold;
          }
          :global(h4) {
            font-weight: 600;
          }
        }
      `}
    </style>
  </div>
)

SchoolRegistration.propTypes = {
  registrationInfo: string,
  registrationUrl: string,
}

export default SchoolRegistration
